export default __webpack_public_path__ + "static/media/Tick.f3cd3a38.svg";